module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.getBlockModifiers()
  }, [_c('div', {
    class: [_vm.block + '-subSections']
  }, _vm._l((_vm.subSections), function(subSection, index) {
    return _c('div', {
      key: subSection,
      class: [_vm.block + '-subSection', {
        'm-current': _vm.currentSubSection == index,
        'm-prev': _vm.currentSubSection > index,
        'm-next': _vm.currentSubSection < index
      }]
    }, [(subSection.full) ? _c('div', {
      class: [_vm.block + '-full', {
        'm-center': subSection.full.center
      }],
      style: ({
        'margin-top': ((subSection.full.marginTop) + "px")
      })
    }, [_c(subSection.full.component, {
      tag: "component",
      attrs: {
        "data": subSection.full.data,
        "sharedData": _vm.sharedData
      }
    })], 1) : _vm._e(), _vm._v(" "), (!subSection.full) ? _c('div', {
      class: [_vm.block + '-topAndBottom']
    }, [_c('div', {
      class: [_vm.block + '-top', {
        'm-center': subSection.top.center
      }],
      style: ({
        'margin-top': ((subSection.top.marginTop) + "px")
      })
    }, [_c(subSection.top.component, {
      tag: "component",
      attrs: {
        "data": subSection.top.data,
        "sharedData": _vm.sharedData
      }
    })], 1), _vm._v(" "), _c('div', {
      class: [_vm.block + '-bottom', {
        'm-center': subSection.bottom.center
      }],
      style: ({
        'margin-top': ((subSection.bottom.marginTop) + "px")
      })
    }, [_c(subSection.bottom.component, {
      tag: "component",
      attrs: {
        "data": subSection.bottom.data,
        "sharedData": _vm.sharedData
      }
    })], 1)]) : _vm._e()])
  })), _vm._v(" "), (_vm.data.video) ? _c('video-full', {
    class: [_vm.block + '-video'],
    attrs: {
      "data": _vm.data.video
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf4eaa90","buble":{"objectAssign":"Object.assign"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/templates/SubSections.vue
// module id = 367
// module chunks = 0